"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#024965",
    d: "M24,7.39V5.67a2.86,2.86,0,0,0-2.86-2.86H2.87A2.86,2.86,0,0,0,0,5.67V7.39H24ZM4,6.24a.57.57,0,1,1,.57-.57A.57.57,0,0,1,4,6.24Zm2.29,0a.57.57,0,1,1,.57-.57A.57.57,0,0,1,6.3,6.24Zm2.29,0a.57.57,0,1,1,.57-.57A.57.57,0,0,1,8.58,6.24Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#024965",
    d: "M24,18.24V8.53H0v9.71A2.86,2.86,0,0,0,2.87,21.1H21.15A2.86,2.86,0,0,0,24,18.24Z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M14.27,14.4a2.68,2.68,0,1,0,2.68,2.68A2.68,2.68,0,0,0,14.27,14.4Zm1.31,4a.11.11,0,0,1-.16,0l-1.34-1.23a.11.11,0,0,1,0-.08V15.85a.11.11,0,0,1,.22,0V17l1.3,1.19A.11.11,0,0,1,15.58,18.38Z"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M16.13,10.07a.2.2,0,0,0-.2-.2H7.27a.2.2,0,0,0-.2.2v2.17h9.05Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M13,14.3V12.63H10.22v6.3h1.61A3.06,3.06,0,0,1,13,14.3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M16.13,14.64v-2H13.37v1.52a3.06,3.06,0,0,1,2.76.49Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M7.07,18.73a.2.2,0,0,0,.2.2H9.83v-6.3H7.07Z"
  })));
};

exports["default"] = _default;